import styled from 'styled-components';
import colors from '../../../../styles/colors';

interface GenericContainerCardProps {
    height?: string;
}

export const GenericContainerCard = styled.div<GenericContainerCardProps>`
    width: 100%;
    height: ${props => props.height || '100%'};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* padding: 1px 0; */
`;

export const SideSpace = styled.div`
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const CenterSpace = styled.div`
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
